<p class="block_title">Настройки контактов</p>
<hr>
<section class="email-profile-settings">
  <span class="email-profile-settings__form">
    <form [formGroup]="emailForm" (ngSubmit)="onSubmitEmail()">
      <p>Смена текущего почтового ящика</p>
      <mat-form-field appearance="outline">
        <mat-label>{{ profile?.user.email }}</mat-label>
        <input matInput #email placeholder="Ваш новый email" formControlName="email">
        <mat-error *ngIf="emailForm.controls.email.invalid">Некоректный email</mat-error>
      </mat-form-field>

      <button [disabled]="emailForm.controls.email.invalid" mat-raised-button color="primary" type="submit">Сменить</button>
    </form>
  </span>

  <span class="email-profile-settings__form">
    <form [formGroup]="telephoneForm" (ngSubmit)="onSubmitTelephone()">
      <p>Смена текущего телефона</p>
      <mat-form-field hintLabel="Пример формата 87776665544" appearance="outline">
        <mat-label>{{ profile?.phone }}</mat-label>
        <input matInput #phone placeholder="Ваш новый телефон" formControlName="phone" type="number">
        <mat-error *ngIf="telephoneForm.controls.phone.invalid">Некоректный телефон</mat-error>
      </mat-form-field>

      <button [disabled]="telephoneForm.controls.phone.invalid" mat-raised-button color="primary" type="submit">Сменить</button>
    </form>
  </span>
</section>